<template>

  <div class="pop-bg"
       v-show="tipsShown.startBargainErrorMsg || tipsShown.isPayErrorMsg||tipsShown.isRuleShown||tipsShown.isPlaceOrderErrorMsg || tipsShown.isBuyPromptShown || tipsShown.isRuleShown || tipsShown.isWechatShareGuideShown || tipsShown.isPaySuccess ||  tipsShown.isPayError">

    <!--活动规则-->
    <div class="pop rule-pop" v-show="tipsShown.isRuleShown">
      <div class="close" @click="closeTips('isRuleShown')"></div>
      <div class="pops">
        <div class="title">
          <div class="line l-line"></div>活动规则<div class="line r-line"></div>
        </div>
        <div class="content">
<!--          <div class="step" v-if="!userAgent.msdk">-->
<!--            <img src="../../../ui/20190114/img/step.png" alt="img">-->
<!--          </div>-->
          <p class="text">1. 活动时间：即日起至<span class="imp">2019年7月31日</span></p>
          <p class="text">2. 砍价怎么玩？</p>
          <p class="text"><span class="block">（1） </span><span class="ms">可任选活动页面皮肤或英雄发起砍价，每个砍价活动有效期<span class="imp">2</span>小时，有效期内邀请好友帮忙砍价，砍价完成后即可用<span class="imp">“砍后价”</span>购买道具。10分钟内砍到底价并支付，可获得1次额外夺宝的机会</span></p>
          <p class="text"><span class="block">（2） </span><span class="ms">次数限制：每个皮肤或者英雄限发起1次砍价；每人可以帮好友发起的每个活动砍<span class="imp">1</span>刀，最多可以帮好友砍<span class="imp">10</span>次，帮砍成功后可免费领取一个助力礼包（每天上限5次，活动期间共10次） </span></p>
          <p class="text"><span class="block">（3） </span><span class="ms">每次砍价金额随机，参与好友越多越容易砍到最低价</span></p>
          <p class="text">3. 暴击规则说明</p>
          <p class="text"><span class="block">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="ms">本期活动中的暴击机会，在帮砍过程中随机出现，一旦触发，即可砍爆底价，低至<span class="imp">1</span>折。</span></p>
          <p class="text"><span class="block">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="ms"><span class="imp">注：活动期间暴击概率7.5%</span></span></p>
          <p class="text">4. 温馨提示</p>
          <p class="text"><span class="block">（1） </span><span class="ms">砍价完成后请及时支付，订单有效期7天，逾期则视为自动放弃资格</span></p>
          <p class="text"><span class="block">（1） </span><span class="ms">支付完成后，道具将以<span class="imp">邮件形式发货</span>，请注意在游戏内查收哦！若因网络原因稍有延迟，请耐心等待</span></p>
        </div>
      </div>
    </div>


    <!--提示购买弹窗-->

    <div class="pop tips-pop buy-pop" v-show="tipsShown.isBuyPromptShown">
      <div class="close" @click="closeTips('isBuyPromptShown')"></div>
      <div class="title">
        <div class="line l-line"></div>
        温馨提示
        <div class="line r-line"></div>
      </div>
      <div class="content">
        <div class="txt" >
          {{bargainInfo.zoneConfirmMsg}}
        </div>
        <div class="txt" v-if="bargainInfo.bargainStatus=='on' && bargainInfo.stopBargainPromptMsg" style="margin-top: -20px;">
          {{bargainInfo.stopBargainPromptMsg}}
        </div>
        <div class="txt" v-if="bargainInfo.buyPromptMsg">
          {{bargainInfo.buyPromptMsg}}
        </div>
      </div>
      <div class="btn-section">
        <div class="btn buy-btn yes-buy-btn wechat-buy-btn l-btn" @click="goToVmallStore" v-if="!userAgent.msdk && bargainInfo.filter_info">
          <p v-if="bargainInfo.filter_info==2311">去购买英雄</p>
          <p v-if="bargainInfo.filter_info==2312">先去购买皮肤</p>
        </div>
        <div class="btn buy-btn yes-buy-btn dq-buy-btn" :class="{'r-btn':(userAgent.QQ || userAgent.weixin) && bargainInfo.filter_info}" @click="otherPay('midasPay')"><p>仍然购买</p></div>
      </div>
<!--      <div class="btn buy-btn yes-buy-btn" v-else @click="gameCoinPay('pay')">-->
<!--        <p v-if="bargainInfo.buyPromptMsg">仍然购买</p>-->
<!--        <p v-else>立即拥有</p>-->
<!--      </div>-->
    </div>

    <!-- 开砍异常弹窗 -->
    <div class="pop tips-pop" v-show="tipsShown.startBargainErrorMsg">
      <div class="close" @click="closeMsg('startBargainErrorMsg')"></div>
      <div class="title">
        <div class="line l-line"></div>
        温馨提示
        <div class="line r-line"></div>
      </div>
      <div class="content">
        <div class="txt">{{tipsShown.startBargainErrorMsg}}</div>
      </div>
      <div class="btn comfirm-btn" @click="closeMsg('startBargainErrorMsg')"><p>确定</p></div>
    </div>

    <!-- 下单异常弹窗 -->
    <div class="pop tips-pop" v-show="tipsShown.isPlaceOrderErrorMsg">
      <div class="close" @click="closeMsg('isPlaceOrderErrorMsg')"></div>
      <div class="title">
        <div class="line l-line"></div>
        温馨提示
        <div class="line r-line"></div>
      </div>
      <div class="content">
        <div class="txt">{{tipsShown.isPlaceOrderErrorMsg}}</div>
      </div>
      <div class="btn comfirm-btn" @click="closeMsg('isPlaceOrderErrorMsg')"><p>确定</p></div>
    </div>

    <!-- 购买异常弹窗 -->
    <div class="pop tips-pop" v-show="tipsShown.isPayErrorMsg">
      <div class="close" @click="closeMsg('isPayErrorMsg')"></div>
      <div class="title">
        <div class="line l-line"></div>
        温馨提示
        <div class="line r-line"></div>
      </div>
      <div class="content">
        <div class="txt">{{tipsShown.isPayErrorMsg}}</div>
      </div>
      <div class="btn comfirm-btn" @click="confirmPayError"><p>确定</p></div>
    </div>
    <!-- ios弹窗 -->
    <!--<div class="pop tips-pop ios-pop">-->
    <!--<div class="close"></div>-->
    <!--<div class="title">-->
    <!--<div class="line l-line"></div>温馨提示<div class="line r-line"></div>-->
    <!--</div>-->
    <!--<div class="content">-->
    <!--<div class="txt">您的点券不足，是否返回游戏购买？</div>-->
    <!--</div>-->
    <!--<div class="btn comfirm-btn"><p>确定</p></div>-->
    <!--</div>-->

    <!--支付成功结果页-->
    <div class="pop paysuccess-pop" v-show="tipsShown.isPaySuccess">
      <div class="close" @click="closeTips('isPaySuccess')"></div>
      <div class="pops">
        <div class="title">
          <div class="line l-line"></div>
          支付成功！
          <div class="line r-line"></div>
        </div>
        <div class="content">
          <div class="shop-pic">
            <div class="border"></div>
            <img :src="bargainInfo.logo" alt="img">
          </div>
          <div class="txt">道具立即发货</div>
          <p class="txt">请登录游戏在邮箱中领取哦！</p>
        </div>
        <div class="btn game-btn" @click="goToGame"><p>进入游戏</p></div>
        <div class="btn game-btn" @click="goBargainAgain" style="margin-top:15px;"><p>再砍一个</p></div>
      </div>
    </div>

    <!-- 分享引导 -->
    <div class="share-tips-pop" style="height: 100%;" @click="closeTips('isWechatShareGuideShown')"
         v-show="tipsShown.isWechatShareGuideShown">
      <div class="tips-pic"></div>
    </div>


  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"
import * as configs from "./config"
// import Raven from "raven-js"
export default {
  name: "PopTips",
  data() {
    return {
      hasNoBalance: false
    }
  },
  props: {
    tipsShown: Object,
    bargainInfo: Object
  },
  computed: {
    ...mapState(["userAgent"]),
    ...mapGetters(["selectedZone", "loginState"])
  },
  methods: {
    ...mapActions(["pay", "reportUserAction", "midasPay"]),
    closeTips(name) {
      this.tipsShown[name] = false
      this.$emit("update:tipsShown", this.tipsShown)
    },
    closeMsg(name) {
      this.tipsShown[name] = ""
      this.$emit("update:tipsShown", this.tipsShown)
    },
    gameCoinPay() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.OWNER_PAY_GAMECOIN
      })
      this.startBuy("pay")
    },
    otherPay() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.OWNER_PAY_OTHER_WAY
      })
      this.startBuy("midasPay")
    },
    startBuy(action) {
      this[action]({
        bargainId: this.bargainInfo.bargainId,
        token: this.bargainInfo.token,
        offerId: this.bargainInfo.offerId,
        billNo: this.bargainInfo.billNo,
        mid: this.bargainInfo.mid,
        realPrice: this.bargainInfo.price * 10
      }).then(() => {
        this.tipsShown.isPaySuccess = true
        this.tipsShown.isPayButtonShown = false
        this.$emit("update:tipsShown", this.tipsShown)
        this.reportUserAction({
          iformat: configs.REPORT.PAGEVIEW.BUY_SUCCESS
        })
        this.tipsShown.isBuyPromptShown = false
      })
      // .catch(res => {
      //   if (res.ret == 1004) {
      //     //点券不足
      //     if (this.userAgent.msdk) {
      //       this.tipsShown.isPayErrorMsg = "您的点券不足，请先购买点券"
      //     } else {
      //       if (this.userAgent.iOS) {
      //         this.tipsShown.isPayErrorMsg = "您的点券不足，是否返回游戏购买？"
      //       }
      //       if (this.userAgent.android) {
      //         this.tipsShown.isPayErrorMsg = "您的点券不足，是否立即购买？"
      //       }
      //     }
      //     this.hasNoBalance = true
      //   } else {
      //     this.tipsShown.isPayErrorMsg = `系统繁忙，请稍候再试${res.ret}`
      //   }
      //   this.reportUserAction({
      //     iformat: configs.REPORT.PAGEVIEW.BUY_FAILURE
      //   })
      //   Raven.captureException(new Error("buy-error"), {
      //     tags: { type: "get-login-state-error" },
      //     extra: {
      //       res,
      //       getters: this.$store.getters,
      //       rootState: this.$store.state
      //     }
      //   })
      // })
    },
    confirmPayError() {
      if (this.hasNoBalance) {
        this.balanceGuide()
      }
      this.closeMsg("isPayErrorMsg")
    },
    balanceGuide() {
      if (!this.userAgent.msdk) {
        if (this.userAgent.iOS) {
          //返回游戏
          location.href = configs.GAME_URL
        }
        if (this.userAgent.android) {
          //跳转到商店
          location.href = configs.RECHARGE_URL
        }
      }
    },
    goToGame() {
      location.href = configs.GAME_URL
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.SUCCESS_BARGAIN_ENTER_GAME
      })
    },
    goBargainAgain() {
      this.closeTips("isPaySuccess")
      this.$router.replace("/")
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.SUCCESS_BARGAIN_AGAIN
      })
    },
    goToVmallStore() {
      location.href = configs.VMALL_URL
    }
  }
}
</script>

<style scoped>
</style>
